// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".desc[data-v-59f14ce1]{color:var(--el-text-color-secondary);display:inline-block;vertical-align:top;margin-left:10px}", ""]);
// Exports
module.exports = exports;
